import { Box } from '@wix/design-system';
import { FeaturesGrid as PlatformFeaturesGrid } from '@wix/premium-purchase-platform/@components';
import { CreativeOffer } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import JpFeatureGridCheck from '../../assets/icons/feature-grid-check-jp.svg';
import { useJapanesePremiumExperience } from '../../hooks/useJapanesePremiumExperience';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import styles from './FeaturesGrid.scss';

interface FeaturesGridFeatureRowValueProps {
  comparisonValue?: CreativeOffer.ComparisonValue;
}

export const FeaturesGridFeatureRowValue = ({
  comparisonValue,
}: FeaturesGridFeatureRowValueProps) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const isJapanesePremiumExperience = useJapanesePremiumExperience();

  if (comparisonValue?.available && comparisonValue?.value?.translationKey) {
    return (
      <PlatformFeaturesGrid.Content.FeatureRow.Value
        value={t(comparisonValue.value.translationKey)}
      />
    );
  }

  if (
    isJapanesePremiumExperience &&
    comparisonValue?.available &&
    !comparisonValue?.value?.translationKey
  ) {
    return (
      <Box
        align="center"
        verticalAlign="middle"
        width="100%"
        dataHook="jp-feature-grid-check"
      >
        <JpFeatureGridCheck />
      </Box>
    );
  }

  return (
    <PlatformFeaturesGrid.Content.FeatureRow.Value
      classNames={{
        checkIcon: styles.checkIcon,
        minusIcon: styles.minusIcon,
      }}
      value={!!comparisonValue?.available}
    />
  );
};
